import { useEffect, useState } from "react";
import { Gift, PartyPopper, Check } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { confetti, playCoin, playFanfare, floatEmojis } from "@/lib/celebrate";
import { whenFree } from "@/lib/popupQueue";

const KEY = "itz_seen_redeems";
const seen = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const busy = () => document.querySelector('[role="dialog"],[data-testid="lucky-wheel-modal"],[data-testid="level-up-modal"],[data-testid="scratch-big-celebration"],[data-testid="jackpot-celebration"]');

export function RedeemCelebration() {
  const { user } = useAuth();
  const [ev, setEv] = useState(null);
  const [sent, setSent] = useState(false);
  useEffect(() => {
    if (!user) return;
    const check = () => {
      if (document.visibilityState !== "visible" || busy()) return;
      api.get("/community/redeem-latest").then(({ data }) => {
        if (!data || seen().includes(data.id)) return;
        whenFree(`redeem-${data.id}`, () => {
          localStorage.setItem(KEY, JSON.stringify([...seen(), data.id].slice(-30)));
          setEv(data); setSent(false);
          playCoin(3); setTimeout(playFanfare, 250);
          setTimeout(() => confetti({ y: innerHeight * 0.55, count: 120, spread: 1.8 }), 350);
          setTimeout(() => confetti({ x: innerWidth * 0.25, y: innerHeight * 0.4, count: 60 }), 900);
          setTimeout(() => confetti({ x: innerWidth * 0.75, y: innerHeight * 0.4, count: 60 }), 1200);
        });
      }).catch(() => {});
    };
    const t = setTimeout(check, 6000);
    const iv = setInterval(check, 15000);
    return () => { clearTimeout(t); clearInterval(iv); };
  }, [user?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!ev) return null;
  return (
    <div className="fixed inset-0 z-[87] flex items-end sm:items-center justify-center p-4 pb-10 bg-rose-950/50 backdrop-blur-sm wheel-fade" data-testid="redeem-celebration" style={{ pointerEvents: "auto" }}>
      <div className="redeem-rise relative w-full max-w-sm rounded-[2rem] bg-gradient-to-b from-white to-rose-50 p-7 pt-14 text-center wheel-frame">
        <span className="absolute -top-10 left-1/2 -translate-x-1/2 w-20 h-20 rounded-3xl pink-gradient flex items-center justify-center shadow-xl shadow-rose-400/50 redeem-gift"><Gift className="w-10 h-10 text-white" /></span>
        <p className="text-[11px] font-extrabold uppercase tracking-[0.3em] text-rose-500">Gerade eingelöst</p>
        <div className="mt-3 flex items-center justify-center gap-3">
          {ev.picture ? <img src={ev.picture} alt={ev.name} className="w-12 h-12 rounded-full object-cover ring-4 ring-rose-100" />
            : <span className="w-12 h-12 rounded-full pink-gradient text-white font-extrabold text-lg flex items-center justify-center ring-4 ring-rose-100">{ev.name?.[0]?.toUpperCase()}</span>}
          <span className="font-display text-xl font-extrabold text-left" data-testid="redeem-celebration-name">{ev.name}</span>
        </div>
        <p className="mt-3 text-base font-semibold text-slate-700" data-testid="redeem-celebration-text">{ev.text.startsWith(ev.name) ? ev.text.slice(ev.name.length).trim() : ev.text}</p>
        <p className="mt-2 text-xs text-slate-400">Sammle weiter Punkte – dein Geschenk wartet auch schon! 💖</p>
        <button type="button" disabled={sent} data-testid="redeem-congrats-btn"
          onClick={(e) => { floatEmojis(e.currentTarget, "🎉", 10); playCoin(2); setSent(true); api.post(`/wheel/jackpot/${ev.id}/congrats`).catch(() => {}); setTimeout(() => setEv(null), 1600); }}
          className="mt-5 w-full py-3 rounded-full bg-amber-100 text-amber-700 font-extrabold inline-flex items-center justify-center gap-2 active:scale-95 transition-transform disabled:opacity-90">
          {sent ? <><Check className="w-5 h-5" /> Glückwunsch gesendet!</> : <><PartyPopper className="w-5 h-5" /> Gratulieren</>}
        </button>
        <button type="button" onClick={() => setEv(null)} data-testid="redeem-celebration-mega" className="mt-3 w-full h-13 py-3.5 rounded-full pink-gradient text-white text-lg font-extrabold shadow-lg shadow-rose-300 active:scale-95 transition-transform wheel-cta">Mega! 🎉</button>
      </div>
    </div>
  );
}
